/**
 * KontekstEndretDialog
 * Blokkerer siden når org-konteksten er byttet i en annen fane eller avvist av serveren.
 */
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

const KontekstEndretDialog: React.FC = () => {
  const { kontekstUtdatert } = useAuth();
  return (
    <Dialog open={kontekstUtdatert}>
      <DialogContent
        skjulLukkeknapp
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Organisasjonen er endret</DialogTitle>
          <DialogDescription>
            Organisasjonen er byttet i en annen fane eller økten er utløpt. Last siden på nytt før du fortsetter.
          </DialogDescription>
        </DialogHeader>
        <Button onClick={() => window.location.reload()}>Last siden på nytt</Button>
      </DialogContent>
    </Dialog>
  );
};

export default KontekstEndretDialog;
